<template>
  <a-modal
    :visible="visible"
    class="modalPrincipal"
    :mask-closable="false"
    :destroy-on-close="true"
    :width="widthModal"
    :body-style="bodyStyle"
    :footer="null"
    centered
    :keyboard="false"
    @cancel="handleClose"
  >
    <template #title>
      <span v-if="fromTickets"> Información del usuario </span>
      <span v-else>
        {{ titleModal }}
        <a-tag v-if="statusTag" :color="statusTag.color">
          {{ statusTag.title }}
        </a-tag>
      </span>
    </template>

    <div class="steps-content">
      <template v-if="record.status === 1 || record.status === 2">
        <users-invite-modal
          :fromTickets="fromTickets"
          :record="record"
          :update="update"
          :loading="loading"
          :canEdit="currentUserCanEdit"
          :showSave="showSave"
          @handleCancel="handleCancel"
          @handleOk="handleOk"
          @onCloseModal="handleClose"
          @updateTable="handleUpdate"
          @onUpdate="showConfirmModal = true"
        />
      </template>

      <template v-if="showResendEmailModal">
        <resend-email-modal
          :record="record"
          :update="update"
          :user-email="contactEmail"
          @handleCancel="handleCancel"
          @updateTable="handleUpdate"
          @handleOk="handleOk"
          @onCloseHideModal="handleClose"
          @onCloseModal="handleClose"
        />
      </template>

      <template v-if="pendingGeneratedUser">
        <EditPendingGeneratedUser
          :record="record"
          @cancel="handleClose"
          @delete="$emit('delete', record)"
          @update="handleShowModalExit"
          @update:table="handleUpdate"
        />
      </template>
    </div>
  </a-modal>
</template>

<script>
import { defineComponent, createVNode } from "vue";
import { Modal } from "ant-design-vue";
import { QuestionCircleOutlined } from "@ant-design/icons-vue";

import { updateProfileSocket } from "@/app/shared/services";
import { RolTypes, UserStatus } from "@/app/shared/utils/enums";
import { UserCreationType, USER_STATUS_TAGS } from "@/app/users/utils/constants";

import UsersInviteModal from "@/app/users/components/modals/UsersInviteModal.vue";
import ResendEmailModal from "@/app/users/components/modals/ResendEmailModal.vue";
import EditPendingGeneratedUser from "@/app/users/components/modals/EditPendingGeneratedUser.vue";

export default defineComponent({
  components: {
    UsersInviteModal,
    ResendEmailModal,
    EditPendingGeneratedUser,
  },
  props: {
    record: {
      required: true,
      type: Object,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    fromTickets: Boolean,
  },
  data() {
    return {
      USER_STATUS_TAGS,
      contactEmail: "",
      // visible: false,
      update: true,
      showConfirmModal: false,
      bodyStyle: {
        height: "650px",
        loading: false,
        padding: "20px 25px 0px",
        position: "relative",
      },
      loading: false,
      UserCreationType,
    };
  },
  computed: {
    usersInfo() {
      return this.$store.getters["getDataUser"];
    },
    showSave() {
      return this.usersInfo?.role?.id === RolTypes.owner
        ? true
        : this.record?.role?.id !== RolTypes.owner;
    },
    currentUserCanEdit() {
      const currentUserRole = this.usersInfo?.role?.id;

      if (currentUserRole === RolTypes.owner) return true;
      if (currentUserRole === RolTypes.administrator)
        return this.record.role?.id === RolTypes.agent;

      return false;
    },
    pendingGeneratedUser() {
      return (
        this.record.status === 4 && this.record.registration_type === UserCreationType.Generated
      );
    },
    /**
     * @return {Boolean} - muestra el modal para reenviar email
     */
    showResendEmailModal() {
      return this.record.status === 4 && this.record.registration_type === UserCreationType.Email;
    },
    /**
     * @return {String} - titulo del modal
     */
    titleModal() {
      if (this.record.status === 1 || this.record.status === 2) return "Editar usuario";
      return this.showResendEmailModal ? "Editar invitación" : "Editar usuario";
    },
    /**
     * @return {Object} - eitqueta de estado
     */
    statusTag() {
      return this.record.status && USER_STATUS_TAGS[this.record.status]
        ? USER_STATUS_TAGS[this.record.status]
        : null;
    },
    widthModal() {
      if (this.pendingGeneratedUser) return 600;
      else if (this.showResendEmailModal) return 576;
      else return 1000;
    },
  },
  methods: {
    showConfirm() {
      if (this.showConfirmModal) {
        Modal.confirm({
          title: "¿Deseas descartar los cambios realizados?",
          content: "Recuerda que si no guardas los cambios registrados, estos se perderán.",
          icon: createVNode(QuestionCircleOutlined),
          okText: "Descartar",
          calcelText: "Cancelar",
          onOk: () => {
            this.showConfirmModal = false;
            this.handleHideModal();
          },
          centered: true,
        });
      } else {
        this.handleHideModal();
      }
    },
    handleClose() {
      this.showConfirm();
    },
    async handleOk(userData) {
      if (this.showConfirmModal) {
        await this.updateUser(userData);
      }
      this.handleUpdate();
      this.handleHideModal();
    },
    handleUpdate() {
      this.$emit("update");
    },
    handleCancel() {
      this.showConfirm();
    },
    handleHideModal() {
      this.$emit("onCloseModal");
      this.update = false;
    },
    async updateUser(newUserData) {
      try {
        this.loading = true;

        await this.$store.dispatch("updateUser", {
          id: this.record.id,
          params: newUserData,
        });

        console.log("new user data", newUserData);
        console.log("usersInfo", this.usersInfo);
        console.log("record", this.record);

        if (newUserData.profile) {
          await updateProfileSocket({
            customer_id: this.usersInfo.customer.id,
            user_id: this.record.id,
            title: "Un administrador te ha cambiado el perfil",
            description:
              "Se te ha asignado un nuevo perfil. Tus permisos podrían cambiar según su configuración.",
          });
        }

        this.update = false;
        this.$message.success("Se guardaron los cambios correctamente");
        this.$store.dispatch("clearUser");
      } catch (error) {
        this.$message.error("Error al actualizar");
        throw Error();
      } finally {
        this.loading = false;
      }
    },
    handleShowModalExit(show) {
      this.showConfirmModal = show;
    },
    colorStatus(status) {
      return status === UserStatus.active ? "green" : "red";
    },
  },
});
</script>

<style lang="sass" scoped>
.vistaDos
  margin: 0 24px
  padding: 20px

.iconoCerrado
  position: absolute
  top: 22px
  right: 16px

:deep(.ant-modal-body)
  padding: 24px 0

.steps-content
  height: 100%
</style>
